var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeebackMessageFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64.24,
    r: 38,
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 65.2398C30 53.2847 36.1703 42.7707 45.5 36.7087",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7036 77.1144C80.4847 77.8955 80.4847 79.1618 79.7036 79.9428C78.9226 80.7239 77.6563 80.7239 76.8752 79.9428L64.4619 67.5295L52.0478 79.9437C51.2667 80.7247 50.0004 80.7247 49.2193 79.9437C48.4383 79.1626 48.4383 77.8963 49.2193 77.1153L61.6335 64.7011L49.2193 52.287C48.4383 51.5059 48.4383 50.2396 49.2193 49.4585C50.0004 48.6775 51.2667 48.6775 52.0478 49.4585L64.4619 61.8727L76.8752 49.4594C77.6563 48.6783 78.9226 48.6783 79.7036 49.4594C80.4847 50.2404 80.4847 51.5068 79.7036 52.2878L67.2903 64.7011L79.7036 77.1144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeebackMessageFail);
export default __webpack_public_path__ + "static/media/Feeback-Message-fail.3e2e5d928299fb18f05d9b48928ea7fc.svg";
export { ForwardRef as ReactComponent };